import React, { useState } from 'react';
import Reports from './Reports';
import CobranzaAnalysis from './CobranzaAnalysis';
import OverdueStats from './OverdueStats';

// Los tres informes bajo un solo botón.
//
// Antes eran tres entradas sueltas en la barra —Reportes, Cobranza y
// Estadísticas— y ninguna decía por su nombre en qué se diferenciaba de las
// otras dos: «Estadísticas» resultaba ser el resumen de vencimientos. Tres
// botones para una idea, en una barra que ya tenía dieciocho.
//
// Las pantallas no se tocan: son las mismas de siempre, solo que ahora se
// llega a ellas por pestañas.

const PESTAÑAS = [
  { id: 'financieros', rotulo: '💰 Financieros', Pantalla: Reports },
  { id: 'cobranza', rotulo: '📈 Cobranza', Pantalla: CobranzaAnalysis },
  { id: 'vencimientos', rotulo: '📋 Vencimientos', Pantalla: OverdueStats },
];

function Informes({ inicial }) {
  const [cual, setCual] = useState(
    PESTAÑAS.some(p => p.id === inicial) ? inicial : 'financieros');

  const activa = PESTAÑAS.find(p => p.id === cual) || PESTAÑAS[0];
  const Pantalla = activa.Pantalla;

  return (
    <div>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap',
                    marginBottom: '18px', borderBottom: '1px solid #e5e7eb',
                    paddingBottom: '12px' }}>
        {PESTAÑAS.map(p => (
          <button key={p.id} onClick={() => setCual(p.id)}
                  style={{
                    padding: '8px 16px', borderRadius: '7px', cursor: 'pointer',
                    fontSize: '14px', fontWeight: p.id === cual ? 700 : 400,
                    border: p.id === cual ? '1px solid #667eea' : '1px solid #e5e7eb',
                    background: p.id === cual ? '#eef2ff' : 'white',
                    color: p.id === cual ? '#4338ca' : '#4b5563',
                  }}>
            {p.rotulo}
          </button>
        ))}
      </div>
      <Pantalla />
    </div>
  );
}

export default Informes;
